module.exports = __webpack_public_path__ + "img/scenes_12.2acd6cba.png";